

























import { computed, defineComponent } from 'vue';
import type { Source } from '@/data';

export default defineComponent({
  name: 'CanvasSource3D',
  props: {
    source: {
      type: Object as () => Source,
      required: true,
    },
  },
  setup(props) {
    const yPositions = computed(() => props.source.pages!.reduce<number[]>((acc, page, index) => {
      const prevY = acc[index - 1] ?? 0;
      const nextY = index === 0 ? 0 : prevY + props.source.pages![index - 1].height;
      acc.push(nextY);
      return acc;
    }, []));
    return { yPositions };
  },
});
